import React from "react";
import PropTypes from "prop-types";
import { ThemeContext } from "../Theme";

import { TextLink } from "../TextLink";
import { CopyText } from "../CopyText";

import styles from "./HintBox.scss";

class HintBoxLink extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
  };

  static contextType = ThemeContext;

  render() {
    const { children } = this.props;

    return (
      <div className={styles.link}>
        <CopyText>
          <TextLink>{children}</TextLink>
        </CopyText>
      </div>
    );
  }
}

export default HintBoxLink;
